import { ProjectSummary } from "../../../api/models";
import { ICardProps } from "../Card.types";

export interface IProjectCardProps extends ICardProps<unknown | null> {
  project: ProjectSummary;
}

export const DefaultProjectCardProps = {
  subscription: {
    data: null,
    isLoading: false,
    error: null,
    isError: false,
  },
};
